package com.neurobs.ccabserver.transcriptreview.components.transcriptreview.components

import com.neurobs.react.StyleUtil
import com.neurobs.ccabserver.transcriptreview.states.{RecordingTranscriptReviewStateGenerator, TestTranscriptReviewStateGenerator, WordAdditionStateGenerator}
import com.neurobs.util.TimeSeconds
import org.scalajs.dom
import org.scalajs.dom.console
import slinky.core.{FunctionalComponent, TagElement}
import slinky.core.annotations.react
import slinky.core.facade.React.createRef
import slinky.web.SyntheticMouseEvent
import slinky.web.html._

@react
object WordAddition {

  case class Props(audioDuration: TimeSeconds)

  val component = FunctionalComponent[Props] { props =>

    val testState = TestTranscriptReviewStateGenerator.accessState
    val wordAdditionState = WordAdditionStateGenerator.accessState

    def innerStyleOpt = wordAdditionState.dimensionAttributes.map(StyleUtil.makeStyle(_:_*))

    def outerStyle = StyleUtil.makeStyle(
      ("height", "20px"),
      ("width", testState.secondsToPixels(props.audioDuration) + "px"),
      ("backgroundColor", "gray"),
      ("cursor", if (wordAdditionState.creatingWord) "col-resize" else "text"),
      ("marginBottom", "40px"),
    )

    def handleMouseDown(event: SyntheticMouseEvent[TagElement#RefType]) = wordAdditionState.handleMouseDown(event)
    def handleMouseUp(event: SyntheticMouseEvent[TagElement#RefType]) = wordAdditionState.handleMouseUp(event)
    def handleMouseMove(event: SyntheticMouseEvent[TagElement#RefType]) = wordAdditionState.handleMouseMove(event)

    div(
      style := outerStyle,
      ref := wordAdditionState.boundingDivRef,
      onMouseDown := {e => handleMouseDown(e)},
      onMouseUp := {e => handleMouseUp(e)},
      onMouseMove := {e => handleMouseMove(e)}
    )(
      innerStyleOpt match  {
        case None => null
        case Some(styling) => div(style := styling)()
      }
    )

  }
}
